import { API_BASE_URL } from '@/config/api';

const API = API_BASE_URL;

/**
 * Create a frozen view-only share of the current analysis (auth required).
 * @returns {Promise<{ token: string, path: string, createdAt: string, name?: string }|null>}
 */
export async function createShareSnapshot(payload) {
  const res = await fetch(`${API}/api/share`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) return null;
  return res.json();
}

/**
 * Public load of a shared analysis (no credentials required).
 * @returns {Promise<{ ok: true, data: object }|{ ok: false, status: number, message: string }>}
 */
export async function fetchShareSnapshot(token) {
  try {
    const res = await fetch(`${API}/api/share/${encodeURIComponent(token)}`, {
      method: 'GET',
      credentials: 'omit',
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      const detail = body?.detail;
      return {
        ok: false,
        status: res.status,
        message: typeof detail === 'string' ? detail : 'Share not found',
      };
    }
    const data = await res.json();
    return { ok: true, data };
  } catch (err) {
    return {
      ok: false,
      status: 0,
      message: err?.message || 'Network error',
    };
  }
}

export function absoluteShareUrl(path) {
  if (!path) return '';
  if (typeof window === 'undefined') return path;
  return `${window.location.origin}${path.startsWith('/') ? path : `/${path}`}`;
}
